import React, { Component } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";

//#region Internal
import SideBar from "../components/SideBar";
import BackButton from "../components/Base/BackButton";
import PageHeader from "../components/Base/ReportFilter";
import VirtualizedGrid from "../components/Grid/VirtualizedGrid";
import CircularProgress from "@material-ui/core/CircularProgress";
import DialogPanel from "../components/Base/FeedBackEditDialog";
import {
  Notification,
  success,
  error,
  warning,
} from "../components/Notification/index";
import getRows from "../util/getRows";

import { Components } from "../assets/Dimensions";
import { Text } from "../assets/Strings";
import { FB, fmtNum, fmtDate, getColumnDefs } from "../assets/feedbackTheme";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RefreshIcon from "@material-ui/icons/Refresh";
import SearchIcon from "@material-ui/icons/Search";

import { sendBackAssignee } from "../api/BookSection";

import { setSelectedBookSectionId } from "../redux/actions/bookSectionAction";
import { setSelectedItem } from "../redux/actions/sidebarAction";
import { setTasks } from "../redux/actions/taskAction";
import { setLinks, addLink } from "../redux/actions/pageHeaderLinkAction";
import { setPageNumber } from "../redux/actions/gridAction";
import { logoutUser } from "../redux/actions/userAction.js";
import ReportContentType from "../enums/ReportContentType";
import {
  getReports,
  updateAnswer,
  updateReport,
  updateCropAnswer,
  getAchievementVideoReports,
  getLectureSectionReports,
} from "../api/FeedBacks";
import { toast } from "react-toastify";
import AchievementReactionsTable from "./AchievementReactions/ReactionsTable";
//#endregion

//#region Inline Style
const styles = {
  container: {
    marginLeft: Components.SideBarWidth + 15,
    paddingTop: 20,
    marginRight: 30,
    paddingBottom: 40,
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 14,
  },
  title: { fontSize: 22, fontWeight: 600, color: FB.text, margin: 0 },
  subtitle: { fontSize: 13, color: FB.textMuted, marginTop: 2 },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
  },
  donePill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontSize: 13,
    fontWeight: 500,
    padding: "5px 12px",
    borderRadius: 999,
    backgroundColor: FB.doneSoft,
    color: FB.done,
    border: `1px solid ${FB.doneBorder}`,
  },
  toggle: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontSize: 13,
    color: FB.textSecondary,
    cursor: "pointer",
  },
  refreshBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontSize: 13,
    fontWeight: 500,
    padding: "6px 12px",
    borderRadius: 8,
    border: `1px solid ${FB.borderStrong}`,
    backgroundColor: FB.surface,
    color: FB.text,
    cursor: "pointer",
  },
  kpiRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: 12,
    margin: "16px 0",
  },
  kpiCard: {
    backgroundColor: FB.surfaceAlt,
    borderRadius: 10,
    padding: "14px 16px",
    border: `1px solid ${FB.border}`,
  },
  kpiLabel: { fontSize: 13, color: FB.textSecondary },
  kpiValue: { fontSize: 24, fontWeight: 600, color: FB.text, marginTop: 4, minHeight: 30 },
  searchRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
    margin: "4px 0 12px",
  },
  searchWrap: { position: "relative", flex: 1, minWidth: 220, maxWidth: 360 },
  searchInput: {
    width: "100%",
    height: 36,
    borderRadius: 8,
    border: `1px solid ${FB.border}`,
    padding: "0 12px 0 34px",
    fontSize: 13,
    outline: "none",
    color: FB.text,
    backgroundColor: FB.surface,
    boxSizing: "border-box",
  },
  searchIcon: {
    position: "absolute",
    left: 10,
    top: "50%",
    transform: "translateY(-50%)",
    color: FB.textMuted,
    fontSize: 18,
  },
  summaryText: { fontSize: 13, color: FB.textMuted, whiteSpace: "nowrap" },
};
//#endregion

class WorkListPage extends Component {
  constructor(props) {
    super(props);

    this._editFieldNames = ["editAssigneeUser"];
    this._editRowData = [];
    this._sendBackRow = [];
    this._rows = [];
    this._columns = [];
    this._columnDefs = [];
    this._maxReportCount = null;
    this._newestDate = null;
    this._openCount = 0;
    this._fetchSeq = 0;
    this._user = {};
    this._selectedCropId = [];

    this.state = {
      editDialog: false,
      sendBackDialog: false,
      isLoading: false,
      // Session-only "done" state (resets on refresh / reload): which reports were
      // marked done and how many this session.
      doneIds: new Set(),
      doneCount: 0,
      hideDone: false,
      searchText: "",
      // Default filter selection on open: Status 0 + Son 30 gün + Order by Count.
      statusType: 0,
      statusDate: 1,
      orderBy: 1,
      cropId: null,
      selectedRowId: null,
      reportContentType: Number(sessionStorage.getItem("reportContentType")) || ReportContentType.BookSectionCrop,
    };
  }

  componentWillMount() {
    this.props.setLinks([
      {
        Text: "FeedBacks",
        href: "/feedbacks",
      },
    ]);
  }

  async componentDidMount() {
    this._user = JSON.parse(localStorage.getItem("user"));
    if (this._user === null) {
      localStorage.clear();
      this.props.logOutUser();
      this.props.history.push("/login");
      return;
    }

    if (
      this.props.location.state !== undefined &&
      this.props.location.state.isFinished === true
    ) {
      success(Text.FinishedSection, 2000);
    }

        // Deep-link support: /feedbacks?cropId=<id> (e.g. from the CMS Reports İncele
    // modal) opens the FeedBack edit modal for that bookSectionCropId directly.
    const cropIdParam = new URLSearchParams(this.props.location.search).get(
      "cropId"
    );
    if (cropIdParam) {
      sessionStorage.setItem(
        "reportContentType",
        String(ReportContentType.BookSectionCrop)
      );
      this.setState(
        {
          reportContentType: ReportContentType.BookSectionCrop,
          cropId: cropIdParam,
          editDialog: true,
        },
        () => this._loadTasks()
      );
      return;
    }


    this.props.setPageNumber(0);
    this.props.setSelectedSideBar("FeedBacks");

    await this._loadTasks();
  }

  _handleClose = (name) => {
    this.setState({
      [name]: false,
      // selectedRowId: null,
      cropId: null,
    });
  };
  
  getCropIdFromFilter = (e)=>{
    return this.setState({
      cropId:e
    })
  }
  modalControl = (e)=>{
    return this.setState({
      editDialog: e,
      ...(!e && { cropId: null }),
    })
  }

  _getAllTasks = async (pageNumber = this.props.PageNumber, { silent = false } = {}) => {
    // The reactions view (<AchievementReactionsTable>) fetches and manages its own
    // data/filters, so skip the legacy report API entirely for that type.
    if (this.state.reportContentType === ReportContentType.AchievementVideoReaction) {
      return { Tasks: [], RowCount: 0, columns: [], rows: [] };
    }
    //filtre payloadları buradan atılıyor
    const params = {
      MonthCount: this.state.statusDate,
      StatusType: this.state.statusType, // 0 --> Calls "Status = 0" ,  1 --> Calls "Status = 1" , 2 --> Calls "Status All"
      OrderBy: this.state.orderBy, // 0 --> Order by date , 1 --> Order By Count
    };
    if (!silent) this.setState({ isLoading: true });
    try {
      let res;
      switch (this.state.reportContentType) {
        case ReportContentType.AchievementVideo:
          res = await getAchievementVideoReports(params, this._user.Token);
          break;
        case ReportContentType.LectureSection:
          res = await getLectureSectionReports(params, this._user.Token);
          break;
        default:
          res = await getReports(params, this._user.Token);
      }
      if (res.status === 200) {
        const data = res.data?.ResponseData ?? res.data;
        const columns = data.length > 0 ? Object.keys(data[0]) : [];
        const rows = this._getRows(data) || [];
        return { Tasks: data, RowCount: data.length, columns, rows };
      } else {
        toast.error("Raporlar getiriliken bir sorun oluştu.");
        error(res, 2000);
        return { Tasks: [], RowCount: 0, columns: [], rows: [] };
      }
    } finally {
      if (!silent) this.setState({ isLoading: false });
    }
  };

  // Single entry point for (re)loading the report grid. A monotonic seq guards
  // against out-of-order responses: a slow fetch (e.g. "Tüm Zamanlar", ~45k rows)
  // can resolve after a newer filter change — without this it would overwrite the
  // newer result. Only the latest-initiated load applies its data.
  _loadTasks = async (pageNumber = this.props.PageNumber, opts = {}) => {
    const seq = ++this._fetchSeq;
    const { Tasks, RowCount, columns, rows } = await this._getAllTasks(
      pageNumber,
      opts
    );
    if (seq !== this._fetchSeq) return;
    this._columns = columns;
    this._rows = rows;
    this._columnDefs = getColumnDefs(this.state.reportContentType, columns);
    const countKey = (this._columnDefs.find((d) => d.type === "count") || {}).key;
    const dateKey = (this._columnDefs.find((d) => d.type === "date") || {}).key;
    this._maxReportCount = countKey
      ? Tasks.reduce((m, t) => Math.max(m, Number(t[countKey]) || 0), 0)
      : null;
    this._newestDate = dateKey
      ? Tasks.reduce((m, t) => {
          const d = t[dateKey];
          return d && (!m || d > m) ? d : m;
        }, null)
      : null;
          // "Bekleyen" counts only open reports (Status 0), so çözülen rows aren't counted
    // as pending. Types without a status column fall back to the full count.
    const statusKey = (this._columnDefs.find((d) => d.type === "status") || {}).key;
    this._openCount = statusKey
      ? Tasks.reduce((n, t) => n + (Number(t[statusKey]) === 0 ? 1 : 0), 0)
      : RowCount;
    this.props.setTasks(Tasks, RowCount);
  };

  _editRow = (e, rowIndex) => {
    try {
      this._editRowData = e;
      //this._selectedCropId = e;

      this.setState({
        editDialog: true,
        selectedRowId: rowIndex,
      });
    } catch (error) {}
  };

  // Mark a report done client-side and non-destructively: the row stays (it
  // green-lights in the grid) and the session counter ticks up. A refresh / reload
  // wipes it — nothing is removed from the list and no refetch happens.
  _markDone = (id) => {
    this.setState((prev) => {
      const next = { editDialog: false, selectedRowId: null };
      if (id != null && !prev.doneIds.has(id)) {
        const doneIds = new Set(prev.doneIds);
        doneIds.add(id);
        next.doneIds = doneIds;
        next.doneCount = prev.doneCount + 1;
      }
      return next;
    });
  };

  markAsDone = async (row) => {
    let res = await updateReport(row[3].content, this.state.reportContentType, sessionStorage.getItem("jwtP"));
    if (res.status === 200) {
      success(Text.MarkedAsDone, 2000);
      this._markDone(row[3].content);
    } 
    else if (res.status === 401){
      toast.error("Prod işlemleriniz tekrardan giriş yapmanız gerekmektedir.")
    }
    else {
      error(res, 2000);
    }
  };
  markAsDoneNEW = async (row) => {
    //bookSectionCropId
    let res = await updateReport(row, ReportContentType.BookSectionCrop, sessionStorage.getItem("jwtP"));
    if (res.status === 200) {
      success(Text.MarkedAsDone, 2000);
      this._markDone(row);
    }
    else if (res.status === 401){
      toast.error("Prod işlemleriniz tekrardan giriş yapmanız gerekmektedir.")
    }
    else {
      error(res, 2000);
    }
  };

  onClickAnswerChange = async (row, option) => {
    const params = {
      BookSectionCropId: row[3].content,
      AnswerOption: option,
    };
    const updateCropAnswerRes = await updateCropAnswer(
      params,
      this._user.Token
    );
    if (updateCropAnswerRes.status === 200) {
      let res = await updateAnswer(params, sessionStorage.getItem("jwtP"));
      if (res.status === 200) {
        success(Text.UpdatedAnswer, 2000);

        // Keep the dialog open (so Mark As Done is reachable next); refresh the
        // grid silently so the loading overlay doesn't cover the open dialog.
        // await this._loadTasks(this.props.PageNumber, { silent: true });
        return true;
      } 
      else if (res.status === 401){
        toast.error("Prod işlemleriniz tekrardan giriş yapmanız gerekmektedir.")
      }
      else {
        error(res, 2000);
        return false;
      }
    } else {
      error(updateCropAnswerRes, 2000);
      return false;
    }
  };
  onClickAnswerChangeNEW = async (row, option) => {
    const params = {
      BookSectionCropId: row,
      AnswerOption: option,
    };
    const updateCropAnswerRes = await updateCropAnswer(
      params,
      this._user.Token
    );
    if (updateCropAnswerRes.status === 200) {
      let res = await updateAnswer(params, sessionStorage.getItem("jwtP"));
      if (res.status === 200) {
        success(Text.UpdatedAnswer, 2000);

        // Keep the dialog open (so Mark As Done is reachable next); refresh the
        // grid silently so the loading overlay doesn't cover the open dialog.
        // await this._loadTasks(this.props.PageNumber, { silent: true });
        return true;
      } 
      else if (res.status === 401){
        toast.error("Prod işlemleriniz tekrardan giriş yapmanız gerekmektedir.")
      }
      else {
        error(res, 2000);
        return false;
      }
    } else {
      error(updateCropAnswerRes, 2000);
      return false;
    }
  };

  _getRows = (data) => {
    return getRows(data, null, null, null);
  };

  _onRowClick = (e) => {
    this.props.setSelectedBookSectionId(e[4].content);
    localStorage.setItem("bookSectionId", e[4].content);
    localStorage.setItem("targetQuestion", e[5].content);
    // Build a new array (don't mutate redux state in place) and skip appending a
    // duplicate crop breadcrumb if one is already present.
    const links = this.props.Links.some((l) => l.href === "/booksectioncrop")
      ? this.props.Links
      : [...this.props.Links, { Text: "Test", href: "/booksectioncrop" }];
    sessionStorage.setItem("fromFeedBack",true)
    this.props.addLink(links);
    const url = `/booksectioncrop`;
    window.open(url, '_blank');
    //this.props.history.push("/booksectioncrop");
  };
  _onRowClickNEW = (e) => {
    //bookSectionId
    //QuestionNumber
    this.props.setSelectedBookSectionId(e.BookSectionId);
    localStorage.setItem("bookSectionId", e.BookSectionId);
    localStorage.setItem("targetQuestion", e.QuestionNumber);
    // Build a new array (don't mutate redux state in place) and skip appending a
    // duplicate crop breadcrumb if one is already present.
    const links = this.props.Links.some((l) => l.href === "/booksectioncrop")
      ? this.props.Links
      : [...this.props.Links, { Text: "Test", href: "/booksectioncrop" }];
    sessionStorage.setItem("fromFeedBack",true)
    this.props.addLink(links);
    const url = `/booksectioncrop`;
    window.open(url, '_blank');
    //this.props.history.push("/booksectioncrop");
  };
  _sendBack = async (e) => {
    if (this._sendBackRow[0].TaskStatus === 5) {
      let req = {
        BookSectionId: this._sendBackRow[0].Id,
      };
      let res = await sendBackAssignee(req, this._user.Token);
      if (res.status === 200) {
        success(Text.SendBackAssignee);

        await this._loadTasks();

        this.setState({
          sendBackDialog: false,
        });
      } else {
        error(res, 2000);
      }
    } else {
      warning(Text.SendBackWarning, 2000);
    }
  };

  _sendBackOpen = (e) => {
    let selectedRow = this.props.Tasks.filter(
      (row) => row.Id.toString() === e.currentTarget.id
    );
    this._sendBackRow = selectedRow;
    this.setState({
      sendBackDialog: true,
    });
  };

  changeFilter = async () => {
    await this._loadTasks();
  };

  // Yenile = reload + clear the session "done" state (a refresh is expected to wipe
  // the green-lit rows and the counter).
  _refresh = () => {
    this.setState({ doneIds: new Set(), doneCount: 0, selectedRowId: null });
    this._loadTasks();
  };

  _typeLabel = () => {
    switch (this.state.reportContentType) {
      case ReportContentType.AchievementVideo:
        return "Kazanım video raporları";
      case ReportContentType.LectureSection:
        return "Konu kartı raporları";
      case ReportContentType.AchievementVideoReaction:
        return "Kazanım video tepkileri";
      default:
        return "Soru raporları";
    }
  };

  _searchPlaceholder = () => {
    switch (this.state.reportContentType) {
      case ReportContentType.AchievementVideo:
        return "AchievementVideoId ara";
      case ReportContentType.LectureSection:
        return "LectureSectionId ara";
      default:
        return "CropId veya soru no ara";
    }
  };


  _renderKpi = (label, value, highlight) => (
    <div
      style={{
        ...styles.kpiCard,
        ...(highlight ? { backgroundColor: FB.doneSoft, borderColor: FB.doneBorder } : {}),
      }}
    >
      <div style={{ ...styles.kpiLabel, ...(highlight ? { color: FB.done } : {}) }}>
        {label}
      </div>
      <div style={{ ...styles.kpiValue, ...(highlight ? { color: FB.done } : {}) }}>
        {this.state.isLoading && !highlight ? (
          <CircularProgress size={18} style={{ color: FB.accent }} />
        ) : (
          value
        )}
      </div>
    </div>
  );

  sorrt = (key) => {
    const compare = (a, b) => {
      if (a[key] < b[key]) {
        return -1;
      }
      if (a[key] > b[key]) {
        return 1;
      }
      return 0;
    };
    return this.props.Tasks.sort(compare);
  };
  render() {
    return (
      <div>
        {this.state.isLoading && (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
            }}
          >
            <CircularProgress size={70} style={{ color: FB.accent }} />
          </div>
        )}
        <SideBar />

        <div style={{ ...styles.container }}>
          <BackButton />
          <div style={styles.titleRow}>
            <div>
              <div style={styles.title}>Geri bildirimler</div>
              <div style={styles.subtitle}>{this._typeLabel()}</div>
            </div>
            {this.state.reportContentType !==
              ReportContentType.AchievementVideoReaction && (
              <div style={styles.headerActions}>
                <span style={styles.donePill}>
                  <CheckCircleIcon style={{ fontSize: 16 }} />
                  {fmtNum(this.state.doneCount)} tamamlandı
                </span>
                <label style={styles.toggle}>
                  <input
                    type="checkbox"
                    checked={this.state.hideDone}
                    onChange={(e) =>
                      this.setState({ hideDone: e.target.checked, selectedRowId: null })
                    }
                  />
                  Tamamlananları gizle
                </label>
                <button style={styles.refreshBtn} onClick={this._refresh}>
                  <RefreshIcon style={{ fontSize: 16 }} /> Yenile
                </button>
              </div>
            )}
          </div>
          <PageHeader
            title="FeedBacks"
            setReportType={(type) => {
              sessionStorage.setItem("reportContentType", type);
              this.setState(
                { reportContentType: type, selectedRowId: null, searchText: "" },
                () => {
                  this.changeFilter();
                }
              );
            }}
            setStatus={(status) => {
              this.setState({ statusType: status, selectedRowId: null }, () => {
                this.changeFilter();
              });
            }}
            setdStatus={(status) => {
              this.setState({ statusDate: status, selectedRowId: null }, () => {
                this.changeFilter();
              });
            }}
            setOrder={(order) => {
              this.setState({ orderBy: order, selectedRowId: null }, () => {
                this.changeFilter();
              });
            }}
            setModal={this._editRow}
            setCropId={this.getCropIdFromFilter}
            cropId={this.state.cropId}
            
          />

          {this.state.reportContentType ===
          ReportContentType.AchievementVideoReaction ? (
            <AchievementReactionsTable />
          ) : (
            <>
              <div style={styles.kpiRow}>
                {this._renderKpi("Toplam rapor", fmtNum(this.props.RowCount))}
                {this._renderKpi(
                  "Açık İş",
                  fmtNum(Math.max(0, (this._openCount || 0) - this.state.doneCount))
                )}
                {this._renderKpi(
                  "Tamamlandı (oturum)",
                  fmtNum(this.state.doneCount),
                  true
                )}
                {this._renderKpi(
                  "En çok raporlanan",
                  this._maxReportCount != null ? fmtNum(this._maxReportCount) : "—"
                )}
                {this._renderKpi(
                  "En yeni rapor",
                  this._newestDate ? fmtDate(this._newestDate) : "—"
                )}
              </div>
              <div style={styles.searchRow}>
                <div style={styles.searchWrap}>
                  <SearchIcon style={styles.searchIcon} />
                  <input
                    style={styles.searchInput}
                    placeholder={this._searchPlaceholder()}
                    value={this.state.searchText}
                    onChange={(e) =>
                      this.setState({ searchText: e.target.value, selectedRowId: null })
                    }
                  />
                </div>
                <span style={styles.summaryText}>
                  {this.state.isLoading
                    ? "Yükleniyor…"
                    : `${fmtNum(this.props.RowCount)} kayıt`}
                </span>
              </div>
              <VirtualizedGrid
                columnDefs={this._columnDefs}
                rows={this._rows}
                options={this._editRow}
                selectedRowId={this.state.selectedRowId}
                doneIds={this.state.doneIds}
                hideDone={this.state.hideDone}
                searchText={this.state.searchText}
              />
            </>
          )}
        </div>

        <DialogPanel
          user={this._user}
          id="editDialog"
          isOpen={this.state.editDialog}
          onClose={() => this._handleClose("editDialog")}
          title={Text.EditWorkList}
          actions={[
            {
              onClick: () => this._handleClose("editDialog"),
              text: Text.Cancel,
            },
            { onClick: this._editTask, text: Text.Edit },
          ]}
          contentComponentNames={this._editFieldNames}
          editRow={this._editRowData}
          selectedCropId = {this.state.cropId}
          reportContentType={this.state.reportContentType}
          onClickAnswerChange={(row, option) =>
            this.onClickAnswerChange(row, option)
          }
          onClickAnswerChangeNEW={(row, option) =>
            this.onClickAnswerChangeNEW(row.Id, option)
          }
          markAsDone={(row) => this.markAsDone(row)}
          rowClick={this._onRowClick}
          markAsDoneNEW={(row) => this.markAsDoneNEW(row.Id)}
          rowClickNEW={this._onRowClickNEW}
          modalControl={this.modalControl}
        />

        <Notification />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  User: state.userReducer.User,
  Tasks: state.taskReducer.Tasks,
  RowCount: state.taskReducer.RowCount,
  PageNumber: state.gridReducer.PageNumber,
  BookSections: state.bookSectionReducer.BookSections,
  Links: state.pageHeaderLinkReducer.Links,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedSideBar: (item) => dispatch(setSelectedItem(item)),
  setTasks: (tasks, rowCount) => dispatch(setTasks(tasks, rowCount)),
  setLinks: (links) => dispatch(setLinks(links)),
  setSelectedBookSectionId: (selectedId) =>
    dispatch(setSelectedBookSectionId(selectedId)),
  addLink: (links) => dispatch(addLink(links)),
  setPageNumber: (pageNumber) => dispatch(setPageNumber(pageNumber)),
  logOutUser: () => dispatch(logoutUser()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(WorkListPage));
